const schema = () => ({
  type: "object",
  required: [],
  properties: {
    title: {
      type: "string",
      title: "عنوان",
    },
    number: {
      type: "number",
      title: "تعداد",
    },
    price: {
      type: "number",
      title: "قیمت",
    },
    details: {
      type: "string",
      title: "توضیحات",
    },
  },
});

export default schema;
